import { CustomPageType } from '../../extViewmodels/sdk/models/CustomPageStyle';
import { useCustomPageStyleByShortCode } from '../queries/useCustomPageStyleByShortCode';
import { isInIframe } from '../utils/iframe';

interface IUseCustomPageStyleResult {
	headerHtml: string;
	footerHtml: string;
	shouldShowBranding: boolean;
}

export const useCustomPageStyle = (shortCode: string): IUseCustomPageStyleResult => {
	const shouldShowBranding = !isInIframe();

	const { data: headerHtml = '' } = useCustomPageStyleByShortCode(shortCode, CustomPageType.Header);

	const { data: footerHtml = '' } = useCustomPageStyleByShortCode(shortCode, CustomPageType.Footer);

	return {
		headerHtml,
		footerHtml,
		shouldShowBranding,
	};
};
